namespace $.$$ {

	export class $shm_hitalama_map_camera_url extends $.$shm_hitalama_map_camera_url {

		commit_timer?: $mol_after_timeout

		commit_delay() {
			return 150
		}

		url_number( key: string ) {
			const raw = this.$.$mol_state_arg.value( key )
			if( raw === null ) return null

			const value = Number( raw )
			return Number.isFinite( value ) ? value : null
		}

		url_precision() {
			return 1000
		}

		url_format( value: number ) {
			const precision = this.url_precision()
			return String( Math.round( value * precision ) / precision )
		}

		local_key( name: 'zoom' | 'shift' ) {
			return this.state_key() + name
		}

		local_zoom( next?: number ) {
			const raw = this.$.$mol_state_local.value( this.local_key( 'zoom' ), next )
			if( raw === null ) return null

			const zoom = Number( raw )
			return Number.isFinite( zoom ) ? zoom : null
		}

		local_shift( next?: $mol_vector_2d<number> ) {
			const shift = this.$.$mol_state_local.value( this.local_key( 'shift' ), next ) as [number, number] | null
			if( !shift ) return null

			const x = Number( shift[0] )
			const y = Number( shift[1] )
			if( !Number.isFinite( x ) || !Number.isFinite( y ) ) return null

			return new this.$.$mol_vector_2d( x, y )
		}

		@ $mol_mem
		live( next?: { zoom: number, shift: $mol_vector_2d<number> } | null ) {
			return next ?? null
		}

		from_url() {
			const zoom = this.url_number( 'zoom' )
			const shift_x = this.url_number( 'shift_x' )
			const shift_y = this.url_number( 'shift_y' )

			if( zoom === null || shift_x === null || shift_y === null ) return null
			return {
				zoom,
				shift: new this.$.$mol_vector_2d( shift_x, shift_y ),
			}
		}

		from_local() {
			const zoom = this.local_zoom()
			const shift = this.local_shift()

			if( zoom === null || shift === null ) return null
			return { zoom, shift }
		}

		current() {
			return this.live() ?? this.from_url() ?? this.from_local() ?? {
				zoom: this.zoom_default(),
				shift: this.shift_default(),
			}
		}

		live_change( next: { zoom: number, shift: $mol_vector_2d<number> } ) {
			this.live( next )
			this.local_zoom( next.zoom )
			this.local_shift( next.shift )
			this.commit_later()
			return next
		}

		commit_later() {
			this.commit_timer?.destructor()
			this.commit_timer = new this.$.$mol_after_timeout(
				this.commit_delay(),
				()=> $mol_wire_async( this ).commit(),
			)
		}

		@ $mol_action
		commit() {
			this.commit_timer = undefined

			const camera = this.live()
			if( !camera ) return

			const next = {
				shift_x: this.url_format( camera.shift.x ),
				shift_y: this.url_format( camera.shift.y ),
				zoom: this.url_format( camera.zoom ),
			}
			const prev = this.$.$mol_state_arg.dict()
			if(
				prev.shift_x === next.shift_x
				&& prev.shift_y === next.shift_y
				&& prev.zoom === next.zoom
			) {
				this.live( null )
				return
			}

			this.$.$mol_state_arg.href( this.$.$mol_state_arg.link({
				... prev,
				... next,
			}) )
			this.$.$mol_state_arg.commit()
			this.live( null )
		}

		@ $mol_mem
		zoom( next?: number ) {
			if( next === undefined ) return this.current().zoom
			return this.live_change({
				... this.current(),
				zoom: next,
			}).zoom
		}

		@ $mol_mem
		shift( next?: $mol_vector_2d<number> ): $mol_vector_2d<number> {
			if( next === undefined ) return this.current().shift
			return this.live_change({
				... this.current(),
				shift: next,
			}).shift
		}

	}

}
